import { createSelector } from '@reduxjs/toolkit';

import { TObjectType, TRealEstateType } from '../../types';
import { selectEntityId } from './selectEntityId';
import { selectFormDefaults } from './selectFormDefaults';
import { selectProgramsVersion } from './selectProgramsVersion';
import { selectRealEstateType } from './selectRealEstateType';
import { selectRegionId } from './selectRegionId';

/* Тело запроса собирают две независимые ветки: useSaveOffers и useShortFormAuthAction */
export const selectSaveOffersParams = createSelector(
  [selectProgramsVersion, selectRegionId, selectRealEstateType, selectEntityId, selectFormDefaults],
  (programsVersion, regionId, realEstateType, entityId, formData) => ({
    programsVersion,
    searchParams: {
      regionId,
      realEstate: {
        type: realEstateType as TRealEstateType,
        id: realEstateType === 'newBuilding' ? entityId : 0,
      },
      objectType: formData.objectType as TObjectType,
      objectCost: formData.objectCost,
      downPayment: formData.downPayment,
      loanTermYears: formData.loanTermYears,
    },
  }),
);
